import React, { forwardRef, memo } from 'react';
import { Checkbox as NBCheckbox, ICheckboxProps, MinusIcon } from 'native-base';

const Checkbox = ({ children, ...props }: ICheckboxProps, ref: any) => (
  <NBCheckbox
    icon={props.isIndeterminate ? <MinusIcon /> : undefined}
    ref={ref}
    {...props}
  >
    {children}
  </NBCheckbox>
);

export default memo(forwardRef(Checkbox));
